module.exports = __webpack_public_path__ + "img/feats-2-640.94eed37a.jpg";